import { cn } from "../utils/className";

export const Heading1 = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) => {
  return (
    <h1
      {...props}
      className={cn(
        "uppercase leading-snug font-light text-5xl lg:text-6xl xl:text-7xl",
        className
      )}
    />
  );
};

export const Heading2 = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) => {
  return (
    <h2
      {...props}
      className={cn(
        "text-4xl md:text-5xl lg:text-6xl mb-4 lg:mb-8 leading-snug font-light",
        className
      )}
    />
  );
};

export const Heading3 = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) => {
  return (
    <h3 {...props} className={cn("text-3xl lg:text-4xl mb-6", className)} />
  );
};

export const Paragraph = ({
  className,
  isLarge = false,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement> & { isLarge?: boolean }) => {
  return (
    <p
      {...props}
      className={cn(
        "text-base md:text-lg text-slate-600 dark:text-slate-300",
        {
          "text-xl md:text-2xl mb-8 lg:mb-12 xl:mb-16 text-slate-800 dark:text-slate-100":
            isLarge,
        },
        className
      )}
    />
  );
};

export const Heading4 = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) => {
  return (
    <h4
      {...props}
      className={cn("text-xl md:text-2xl font-semibold mb-3", className)}
    />
  );
};
